import { useOverlays } from "contexts/OverlayContext";
import { ScheduleLockedPeriodsModal } from "./ScheduleLockedPeriodsModal";

export const ScheduleLockedPeriodsModalWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"scheduleLockedPeriods">(
        "scheduleLockedPeriods",
    );

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <ScheduleLockedPeriodsModal
            show={!overlayIsClosing}
            error={overlayInfo.data}
            onHide={closeOverlay}
        />
    );
};
